<template>
	<div>
		<div class="ypage-box">
			<div>
				<div data-v-486d5814="" data-v-30babe2d="" class="my-header">
					<div data-v-486d5814=""
						class="header-row van-row van-row--flex van-row--align-center van-row--justify-space-between">
						<div data-v-486d5814="" class="van-col van-col--8">
							<div data-v-459e9abf="" class="van-dropdown-menu">
								<div class="van-dropdown-menu__bar" @click="lang_open()">
									<div role="button" tabindex="0" class="van-dropdown-menu__item"><span
											class="van-dropdown-menu__title" style="">
											<div class="van-ellipsis" id="lang_text">{{xz_lang}}</div>
										</span></div>
								</div>
								<div data-v-459e9abf="">
									<div class="van-dropdown-item van-dropdown-item--down" style="top: 48.9531px;;"
										id="lang_div" v-show="lang_div">
										<div class="van-overlay"
											style="z-index: 2003; position: absolute; animation-duration: 0.2s; display: ;"
											@click="lang_open()">
										</div>
										<div class="van-popup van-popup--top van-dropdown-item__content"
											style="transition-duration: 0.2s; z-index: 2004; display: ;">

											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option" style=""
												@click="change('en','English')">
												<div class="van-cell__title"><span>English</span></div>
											</div>

											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option">
												<div class="van-cell__title" @click="change('tu','Türkçe')">
													<span>Türkçe</span>
												</div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option">
												<div class="van-cell__title" @click="change('po','Português')">
													<span>Português</span>
												</div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option">
												<div class="van-cell__title" @click="change('al','عربي')">
													<span>عربي</span>
												</div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option">
												<div class="van-cell__title" @click="change('de','Deutsch')">
													<span>Deutsch</span>
												</div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option">
												<div class="van-cell__title" @click="change('xi','español')">
													<span>español</span>
												</div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option">
												<div class="van-cell__title" @click="change('yi','Italiano')">
													<span>Italiano</span>
												</div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option">
												<div class="van-cell__title" @click="change('el','Русский')">
													<span>Русский</span>
												</div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option">
												<div class="van-cell__title" @click="change('ja','日本')">
													<span>日本</span>
												</div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option"
												@click="change('zh','简体中文')">
												<div class="van-cell__title"><span>简体中文</span></div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option "
												@click="change('fa','繁体中文')">
												<div class="van-cell__title"><span>繁体中文</span></div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div data-v-486d5814="" class="van-col van-col--8">
							<div data-v-486d5814="" class="flex align-center justify-center">
								<h2 data-v-486d5814="" class="plat-name">Pool</h2>
							</div>
						</div>
						<div data-v-486d5814="" class="van-col van-col--8" style="text-align: right; padding-right: 10px;">
							<button data-v-486d5814="" disabled="disabled"
								class="van-button van-button--default van-button--mini van-button--plain van-button--disabled van-button--hairline van-hairline--surround"
								style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 100%;">
								<div data-v-486d5814="" class="van-button__content"><img :src="bi_img" style="width: 20px;height: 20px;"/><span data-v-486d5814=""
										class="van-button__text"
										style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;font-size:10px;margin-left: 10px;">{{selectedAccount}}</span>
								</div>
							</button>
						</div>
					</div>
				</div> <!---->
			</div>
			<div data-v-e1a5b7f8="" class="share" style="margin-top: 0px;">
				<div data-v-e1a5b7f8="" class="share-bg">
					<h2 data-v-e1a5b7f8="" class="tl p-l-10 lg-title">{{$t('推荐朋友')}}</h2>
					<h2 data-v-e1a5b7f8="" class="tl p-l-10">{{$t('一起赚取加密货币')}}</h2>
					<p data-v-e1a5b7f8="" class="tl p-l-10"> </p>
					<div data-v-e1a5b7f8="" class="tl p-l-10 active-color">{{$t('查看详情')}}
					</div> <!---->
				</div>

				<div class="van-tabs van-tabs--line">
					<div class="van-tabs__wrap">
						<div role="tablist" class="van-tabs__nav van-tabs__nav--line">
							<div role="tab" class="van-tab van-tab--active" aria-selected="true" @click="qiehuan(1)">
								<span class="van-tab__text van-tab__text--ellipsis"></span>{{$t('团队')}}
							</div>

							<div role="tab" class="van-tab van-tab--active" aria-selected="true" @click="qiehuan(2)">
								<span class="van-tab__text van-tab__text--ellipsis">{{$t('推荐')}}</span>
							</div>


							<div role="tab" class="van-tab van-tab--active" aria-selected="true" @click="qiehuan(3)">
								<span class="van-tab__text van-tab__text--ellipsis">{{$t('记录')}}</span>
							</div>

							<div class="van-tabs__line" style="left: 37px;" v-show="td_xia">
							</div>

							<div class="van-tabs__line" style="left: 153px;" v-show="tj_xia">
							</div>

							<div class="van-tabs__line" style="left: 268px;" v-show="jl_xia">
							</div>
						</div>
					</div>
					<div class="van-tabs__content van-tabs__content--animated">
						<div class="van-tabs__track"
							style="transform: translate3d(0%, 0px, 0px); transition-duration: 0.3s;">
							<div role="tabpanel" class="van-tab__pane-wrapper" v-show="td_div">
								<div class="van-tab__pane">
									<div data-v-e1a5b7f8="" class="team-info">
										<div data-v-e1a5b7f8="" class="flex align-center justify-between">
											<div data-v-e1a5b7f8="" class="block-info m-r-20">
												<h3 data-v-e1a5b7f8="">{{res_team_data.all_ren_count}}</h3>
												<h4 data-v-e1a5b7f8="">{{$t('团队规模')}}</h4>
											</div>
											<div data-v-e1a5b7f8="" class="block-info">
												<h3 data-v-e1a5b7f8="">0</h3>
												<h4 data-v-e1a5b7f8="">{{$t('直接发起人')}}</h4>
											</div>
										</div>
										<div data-v-e1a5b7f8="" class="flex align-center justify-between">
											<div data-v-e1a5b7f8="" class="block-info m-r-20">
												<h3 data-v-e1a5b7f8="">{{res_team_data.all_zong_shouyi}}</h3>
												<h4 data-v-e1a5b7f8="">{{$t('总收入')}}（{{type}}）</h4>
											</div>
											<div data-v-e1a5b7f8="" class="block-info">
												<h3 data-v-e1a5b7f8="">{{res_team_data.all_today_shouyi}}</h3>
												<h4 data-v-e1a5b7f8="">{{$t('今天的收入')}}（{{type}}）</h4>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div role="tabpanel" class="van-tab__pane-wrapper" v-show="tj_div">
								<div class="van-tab__pane">
									<div data-v-e1a5b7f8="" class="share-link-con">
										<h3 data-v-e1a5b7f8="">{{$t('我的推荐链接')}}</h3>
										<div data-v-e1a5b7f8="" class="van-cell-group">
											<div data-v-e1a5b7f8=""
												class="van-cell van-cell--center van-field van-field--disabled">
												<div class="van-cell__value van-cell__value--alone van-field__value">
													<div class="van-field__body"><input type="text" disabled="disabled"
															class="van-field__control" value=""
															style="-webkit-text-fill-color: black;" id="yaoqing_url">
														<div class="van-field__button"><button data-v-e1a5b7f8=""
																data-clipboard-text="https://bnbqddm.csall8888.top?invite=undefined"
																class="btn-copy van-button van-button--warning van-button--mini"
																@click="f()" id="fuzhi">
																<div data-v-e1a5b7f8="" class="van-button__content">
																	<span data-v-e1a5b7f8="" class="van-button__text">{{$t('复制')}}
																	</span>
																</div>
															</button></div>
													</div>
												</div>
											</div>
										</div>
										<p data-v-e1a5b7f8=""></p>
										<div data-v-e1a5b7f8="" class="earn-tip flex align-center justify-around">
											<div data-v-e1a5b7f8=""><img data-v-e1a5b7f8=""
													src="../../public/img/ChooseCommission.03ba2d8e_03ba2d8eb9626faa5abfff94e1605de3.svg"
													width="60">
												<h3 data-v-e1a5b7f8="">{{$t('1. 获取链接')}}</h3>
											</div>
											<div data-v-e1a5b7f8=""><img data-v-e1a5b7f8=""
													src="../../public/img/InviteFriends.6f4b6101_6f4b610116e84db9c8e5d19fe90fa5e8.svg"
													width="60">
												<h3 data-v-e1a5b7f8="">{{$t('2. 邀请朋友')}}</h3>
											</div>
											<div data-v-e1a5b7f8=""><img data-v-e1a5b7f8=""
													src="../../public/img/EarnBitcoin.3199a322_3199a322edae452f2d9d90e435de554c.svg"
													width="60">
												<h3 data-v-e1a5b7f8="">{{$t('3. 赚取加密货币')}}</h3>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div role="tabpanel" class="van-tab__pane-wrapper" v-show="jl_div">
								<div class="van-tab__pane">
									<div data-v-e1a5b7f8="" class="team_record-con">
										<div data-v-563b5b3b="" data-v-e1a5b7f8="" class="list-wrap">
											<div data-v-563b5b3b="" class="filters flex align-center justify-start">
												<span data-v-563b5b3b="">{{$t('等级')}}</span>
												<div data-v-563b5b3b=""><span data-v-563b5b3b=""
														class="tags van-tag van-tag--medium van-tag--default"
														style="background: rgb(0, 82, 255); color: rgb(255, 255, 255);"
														id="sj_0" @click="tz111(0)">{{$t('全部')}}
													</span> <span data-v-563b5b3b=""
														class="tags van-tag van-tag--medium van-tag--default"
														style="background: rgb(255, 255, 255); color: rgb(0, 82, 255);"
														id="sj_1" @click="tz111(1)">{{$t('1 级')}}
													</span> <span data-v-563b5b3b=""
														class="tags van-tag van-tag--medium van-tag--default"
														style="background: rgb(255, 255, 255); color: rgb(0, 82, 255);"
														id="sj_2" @click="tz111(2)">{{$t('2 级')}}
													</span> <span data-v-563b5b3b=""
														class="tags van-tag van-tag--medium van-tag--default"
														style="background: rgb(255, 255, 255); color: rgb(0, 82, 255);"
														id="sj_3" @click="tz111(3)">{{$t('3 级')}}
													</span></div>
											</div>
											<div data-v-3e39609a=""
												class="tb-header van-row van-row--flex van-row--align-center van-row--justify-space-between"
												style="border-left: none; border-right: none;">
												<div data-v-3e39609a="" class="van-col van-col--6"
													style="text-align: center;">{{$t('用户地址')}}</div>
												<div data-v-3e39609a="" class="van-col van-col--6"
													style="text-align: center;">{{$t('币种')}}
												</div>
												<div data-v-3e39609a="" class="van-col van-col--6"
													style="text-align: center;">{{$t('金额')}}

												</div>

											</div>
											<div data-v-563b5b3b="" class="no-data">
												<div v-for="item in res_team_list" :key="item">
													<div data-v-3e39609a="" class="van-col van-col--8"
														style="text-align: center;">
														{{item.address.substr(0, 4)}}...{{item.address.substr(-4)}}

													</div>
													<div data-v-3e39609a="" class="van-col van-col--8"
														style="text-align: center;">USDT
													</div>
													<div data-v-3e39609a="" class="van-col van-col--8"
														style="text-align: center;">
														{{item.balance}}
													</div>
												</div>

											</div>
										</div>
									</div>
								</div>
							</div>

						</div>
					</div>




				</div>
			</div> <!---->
		</div>
		<div>
			<div data-v-2120af5d="" data-v-30babe2d="">
				<div data-v-2120af5d="" class="van-tabbar__placeholder" style="height: 50px;">
					<div class="van-tabbar van-tabbar--fixed">
						<div data-v-2120af5d="" class="van-tabbar-item" @click="tz('/')">
							<div class="van-tabbar-item__icon"><i class="van-icon van-icon-home-o"></i></div>
							<div class="van-tabbar-item__text">{{$t('首页')}}</div>
						</div>
						<div data-v-2120af5d="" class="van-tabbar-item" @click="tz('pool')">
							<div class="van-tabbar-item__icon"><i class="van-icon van-icon-gem"></i></div>
							<div class="van-tabbar-item__text">{{$t('我的矿池')}}</div>
						</div>
						<div data-v-2120af5d="" class="van-tabbar-item" @click="tz('exchange')">
							<div class="van-tabbar-item__icon"><i class="van-icon van-icon-paid"></i></div>
							<div class="van-tabbar-item__text">{{$t('提取')}}</div>
						</div>
						<div data-v-2120af5d="" class="van-tabbar-item van-tabbar-item--active">
							<div class="van-tabbar-item__icon"><i class="van-icon van-icon-friends-o"></i></div>
							<div class="van-tabbar-item__text">{{$t('推荐')}}</div>
						</div>
						<div data-v-2120af5d="" class="van-tabbar-item" @click="tz('account')">
							<div class="van-tabbar-item__icon"><i class="van-icon van-icon-user-o"></i></div>
							<div class="van-tabbar-item__text">{{$t('账户')}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
	import Web3 from 'web3'
	import axios from 'axios'
	import {
		ethers
	} from 'ethers';
	import {
		useI18n
	} from 'vue-i18n'

	import domain from '../../public/domain';
	import layer from "layui-layer";

	export default {
		name: 'App',
		data() {
			return {
				selectedAccount: '',
				address: '',
				lang_div: false,
				xz_lang: 'English',
				res_team_data: {
					all_ren_count: 0,
				},
				td_xia: true,
				tj_xia: false,
				jl_xia: false,
				td_div: true,
				tj_div: false,
				jl_div: false,
				yq_url: '',
				res_team_list: [],
				type: 'ETH',
				bi_img: '../../img/eth.png',
			}
		},

		methods: {
			tz111(level) {
				var address = sessionStorage.getItem("address");
				let type = sessionStorage.getItem('type');
				var newtype = '';
				if (type == "ETH") {
					newtype = 'erc';
				} else {
					newtype = 'bsc';
				}
				var im = this
				axios({
						method: 'get',
						url: domain.publicUrl + "/api/api/team_list?type=" + newtype + "&address=" + address +
							"&level=" + level
					})
					.then(function(response) {
						console.log(response.data.data)
						im.res_team_list = response.data.data

					})
					.catch(function(error) {
						console.log(error);
					});
				if (level == 0) {
					document.querySelector('#sj_0').style.color = 'rgb(255, 255, 255)'
					document.querySelector('#sj_0').style.background = 'rgb(0, 82, 255)'
					document.querySelector('#sj_1').style.color = 'rgb(0, 82, 255)'
					document.querySelector('#sj_1').style.background = 'rgb(255, 255, 255)'
					document.querySelector('#sj_2').style.color = 'rgb(0, 82, 255)'
					document.querySelector('#sj_2').style.background = 'rgb(255, 255, 255)'
					document.querySelector('#sj_3').style.color = 'rgb(0, 82, 255)'
					document.querySelector('#sj_3').style.background = 'rgb(255, 255, 255)'


				} else if (level == 1) {
					document.querySelector('#sj_0').style.color = 'rgb(0, 82, 255)'
					document.querySelector('#sj_0').style.background = 'rgb(255, 255, 255)'
					document.querySelector('#sj_1').style.color = 'rgb(255, 255, 255)'
					document.querySelector('#sj_1').style.background = 'rgb(0, 82, 255)'
					document.querySelector('#sj_2').style.color = 'rgb(0, 82, 255)'
					document.querySelector('#sj_2').style.background = 'rgb(255, 255, 255)'
					document.querySelector('#sj_3').style.color = 'rgb(0, 82, 255)'
					document.querySelector('#sj_3').style.background = 'rgb(255, 255, 255)'


				} else if (level == 2) {
					document.querySelector('#sj_0').style.color = 'rgb(0, 82, 255)'
					document.querySelector('#sj_0').style.background = 'rgb(255, 255, 255)'
					document.querySelector('#sj_1').style.color = 'rgb(0, 82, 255)'
					document.querySelector('#sj_1').style.background = 'rgb(255, 255, 255)'
					document.querySelector('#sj_2').style.color = 'rgb(255, 255, 255)'
					document.querySelector('#sj_2').style.background = 'rgb(0, 82, 255)'
					document.querySelector('#sj_3').style.color = 'rgb(0, 82, 255)'
					document.querySelector('#sj_3').style.background = 'rgb(255, 255, 255)'

				} else if (level == 3) {
					document.querySelector('#sj_0').style.color = 'rgb(0, 82, 255)'
					document.querySelector('#sj_0').style.background = 'rgb(255, 255, 255)'
					document.querySelector('#sj_1').style.color = 'rgb(0, 82, 255)'
					document.querySelector('#sj_1').style.background = 'rgb(255, 255, 255)'
					document.querySelector('#sj_2').style.color = 'rgb(0, 82, 255)'
					document.querySelector('#sj_2').style.background = 'rgb(255, 255, 255)'
					document.querySelector('#sj_3').style.color = 'rgb(255, 255, 255)'
					document.querySelector('#sj_3').style.background = 'rgb(0, 82, 255)'

				}

			},
			qiehuan(type) {
				if (type == 1) {
					this.td_xia = true,
						this.tj_xia = false,
						this.jl_xia = false,
						this.td_div = true,
						this.tj_div = false,
						this.jl_div = false
				} else if (type == 2) {
					this.td_xia = false,
						this.tj_xia = true,
						this.jl_xia = false,
						this.td_div = false,
						this.tj_div = true,
						this.jl_div = false
				} else if (type == 3) {
					this.td_xia = false,
						this.tj_xia = false,
						this.jl_xia = true,
						this.td_div = false,
						this.tj_div = false,
						this.jl_div = true
				}
			},
			tz(url) {
				window.location.href = '/#'+url
			},
			change(type, name) {

				console.log(this.$i18n.locale)
				this.$i18n.locale = type
				this.lang_div = false
				this.xz_lang = name
				
				sessionStorage.setItem("lang_type", type);
			},
			lang_open() {
				if (this.lang_div == true) {
					this.lang_div = false
				} else {
					this.lang_div = true
				}
			},
			async wakeUpWallet() {

				this.bi_img = sessionStorage.getItem('bi_img');
				this.type = sessionStorage.getItem('bi_type');
				var address = sessionStorage.getItem("address");
				if (!address) {
					if (window.ethereum) {
						window.ethereum.enable().then((res) => {
							var address = res[0];
							console.log(address)
							this.selectedAccount = address.substr(0, 4) + "..." + address.substr(-4);
							this.address = address;

							sessionStorage.setItem("selectedAccount", this.selectedAccount);
							sessionStorage.setItem("address", this.address);
						})
					} else {
						// 		const web3 = new Web3(window.ethereum)
						await window.ethereum.request({
							method: 'eth_requestAccounts'
						});
						this.web3 = await new Web3(window.ethereum);
						this.connected = true;
						console.log("已连接钱包");
						alert("请安装钱包")
					}
				} else {
					this.selectedAccount = sessionStorage.getItem("selectedAccount");
					this.address = sessionStorage.getItem("address");
				}
				
				
				await window.ethereum.on('chainChanged', (chainId) => {
					// 正确处理链更改之后的业务流程可能很复杂。官方建议链更改只有重新加载页面
					console.log("chainId", chainId)
					window.location.reload();
				});

			},
			get_yue() {
				var lang = this.$i18n.locale
				var name = "English"
				if (lang == 'zh') {
					name = '简体中文'
				} else if (lang == 'fa') {
					name = '繁体中文'
				} else if (lang == 'en') {
					name = 'English'
				} else if (lang == 'po') {
					name = 'Português'
				} else if (lang == 'al') {
					name = 'عربي'
				} else if (lang == 'de') {
					name = 'Deutsch'
				} else if (lang == 'xi') {
					name = 'español'
				} else if (lang == 'yi') {
					name = 'Italiano'
				} else if (lang == 'el') {
					name = 'Русский'
				} else if (lang == 'ja') {
					name = '日本語'
				} else if (lang == 'tu') {
					name = 'Türkçe'
				}
				this.xz_lang = name



				var address = sessionStorage.getItem("address");
				let type = sessionStorage.getItem('type');
				var newtype = '';
				if (type == "ETH") {
					newtype = 'erc';
				} else {
					newtype = 'bsc';
				}


				var im = this
				axios({
						method: 'get',
						url: domain.publicUrl + "/api/api/get_yue?type=" + newtype + "&address=" + address
					})
					.then(function(response) {
						console.log(response.data.data)
						im.user_data = response.data.data
						var yq_url = window.location.hostname + "?code=" + response.data.data.inviteCode

						document.getElementById("yaoqing_url").value = yq_url;

					})
					.catch(function(error) {
						console.log(error);
					});
			},
			get_team_data() {
				var address = sessionStorage.getItem("address");
				let type = sessionStorage.getItem('type');
				var newtype = '';
				if (type == "ETH") {
					newtype = 'erc';
				} else {
					newtype = 'bsc';
				}


				var im = this
				axios({
						method: 'get',
						url: domain.publicUrl + "/api/api/team_data?type=" + newtype + "&address=" + address
					})
					.then(function(response) {
						console.log(response.data.data)
						im.res_team_data = response.data.data

					})
					.catch(function(error) {
						console.log(error);
					});
			},
			f() {
				var text = document.getElementById("yaoqing_url").value; //获取要复制的文本
				this.copyText(text);
			},
			copyText(text) { //拷贝文本函数
				var oInput = document.createElement('input'); //创建一个input标签
				oInput.value = text; //设置value属性
				document.body.appendChild(oInput); //挂载到body下面
				oInput.select(); // 选择对象
				document.execCommand("Copy"); // 执行浏览器复制命令
				oInput.className = 'oInput';
				oInput.style.display = 'none';

				var lang = this.$i18n.locale
				var msg = "操作成功"
				if (lang == 'zh') {
					msg = "操作成功"
				} else if (lang == 'fa') {
					msg = "操作成功"
				} else if (lang == 'en') {
					msg = "Success"
				} else if (lang == 'po') {
					msg = "操作成功"
				} else if (lang == 'al') {
					msg = "操作成功"
				} else if (lang == 'de') {
					msg = "操作成功"
				} else if (lang == 'xi') {
					msg = "操作成功"
				} else if (lang == 'yi') {
					msg = '操作成功'
				} else if (lang == 'el') {
					msg = "操作成功"
				} else if (lang == 'ja') {
					msg = "操作成功"
				} else if (lang == 'tu') {
					msg = "操作成功"
				}
				layer.msg(msg, {
					icon: 1,
					time: 1500
				}); //提示框
			},
			fn() {
				var lang_type = sessionStorage.getItem("lang_type");
				var name = "English"
				if(!lang_type){
					name = "English"
				}else{
					if (lang_type == 'zh') {
						name = '简体中文'
					} else if (lang_type == 'fa') {
						name = '繁体中文'
					} else if (lang_type == 'en') {
						name = 'English'
					} else if (lang_type == 'po') {
						name = 'Português'
					} else if (lang_type == 'al') {
						name = 'عربي'
					} else if (lang_type == 'de') {
						name = 'Deutsch'
					} else if (lang_type == 'xi') {
						name = 'español'
					} else if (lang_type == 'yi') {
						name = 'Italiano'
					} else if (lang_type == 'el') {
						name = 'Русский'
					} else if (lang_type == 'ja') {
						name = '日本語'
					} else if (lang_type == 'tu') {
						name = 'Türkçe'
					}
				}
				
				
				this.xz_lang = name
			},

		},
		mounted: function() { //自动触发写入的函数
			this.wakeUpWallet();
			this.get_team_data();
			this.get_yue();
			this.tz111(0);
			this.fn();
		}
	}
</script>

<style>
</style>